import React from "react";
import { OrderStatus, TApiOrder } from "../../api/endpoints/Order";
import { Table } from "react-bootstrap";
import '../../scss/components/_order-list.scss';
import OrderListContent from "./OrderListContent";
import { Nullable } from "../../../types/utils";

export interface IProps {
  status?: OrderStatus;
  loading: boolean;
  error: boolean;
  orders: Array<TApiOrder>;
  onOrderChange?: (order?: Nullable<TApiOrder>) => void;
}

const filterByStatus = (orders: Array<TApiOrder>, status: OrderStatus) => {
  return orders.filter(order => order.status === status);
}

const OrderList = (props: IProps) => {
  const { status, loading, error, orders, onOrderChange } = props;

  const filteredOrders = status ? filterByStatus(orders, status) : orders

  return (
    <div className="order-list">
      <Table>
        <thead>
          <tr>
            <th style={{ width: '6rem' }}>Ref no.</th>
            <th style={{ minWidth: '30%' }}>Name</th>
            <th>Customer</th>
            <th>Type</th>
            <th>Status</th>
            <th>Last updated</th>
          </tr>
        </thead>
        <tbody>
          <OrderListContent
            orders={filteredOrders}
            onOrderChange={onOrderChange}
            loading={loading}
            error={error}
          />
        </tbody>
      </Table>
    </div>
  )
}

export default OrderList;
